var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13783 19C4.72141 19 4 18.2698 4 16.7302V10.1935C4 8.82991 4.58944 8.09971 5.73314 7.96774V5.94428C5.73314 2.80352 7.84457 1 10.4223 1C13 1 15.1202 2.80352 15.1202 5.94428V7.96774C16.2639 8.09971 16.8446 8.82991 16.8446 10.1935V16.7302C16.8446 18.2698 16.1232 19 14.7155 19H6.13783ZM7.82698 5.83871V7.94135H13.0352V5.83871C13.0352 4.05279 11.8651 3.01466 10.4223 3.01466C8.97947 3.01466 7.82698 4.05279 7.82698 5.83871Z",
    fill: "#5A5976"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.6bf284dbdc8233718dde60cd1722e32b.svg";
export { ForwardRef as ReactComponent };